<template>
	<div class="loading_animation">
		<!-- <lottie
			:options="defaultOptions"
			:width="200"
			v-on:animCreated="handleAnimation"
		/> -->

		<p v-html="label"></p>
	</div>
</template>

<script>
// import Lottie from 'vue-lottie';
import * as animationData from '../../images/loading_animation.json';

export default {
	data() {
		return {
			defaultOptions: { animationData: animationData },
			animationSpeed: 1,
		};
	},

	props: {
		label: {
			default: 'Loading Results ...',
		},
	},

	computed: {},

	watch: {},

	methods: {
		handleAnimation: function (anim) {
			this.anim = anim;
		},

		stop: function () {
			this.anim.stop();
		},

		play: function () {
			this.anim.play();
		},

		pause: function () {
			this.anim.pause();
		},

		onSpeedChange: function () {
			this.anim.setSpeed(this.animationSpeed);
		},
	},

	components: {
		// lottie: Lottie,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.loading_animation {
	padding: 0;

	p {
		margin: 0 auto 0;
		text-align: center;
		display: block;
		font: normal normal normal 14px/20px var(--primary-font-family);
		color: var(--midnight);
		opacity: 0.7;
	}
}
</style>
